import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
// import { AppMainService } from 'src/app/app-main.service';
import { Status } from '../../../../../models/statusEnums' //'src/app/models/statusEnums';
import { NoteService } from '../../../api/api' //'../../api/note.service';
import { Note, NoteAttachment } from '../../../model/models';
import { uploadFiles, validateFiles } from '../../../upload-files';
// import { AppMainComponent } from './../../../app.main.component';
import { images } from '../../../activityImages' //"src/app/shared/activityImages";
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { DatePipe } from '@angular/common';
import { Log, LogAttachment } from 'src/app/shared/model/models';
import { LogService } from 'src/app/shared/api/log.service';
import { LogService as CustomLogService } from '../../shared-logs/log-service.service';
import { EmailAudit, Type } from 'src/app/shared/model/models';
import { EmailThread } from '../../../model/models';
import { EmailAuditService } from 'src/app/shared/api/api';
import * as moment from "moment";
import { DocumentViewerService } from '../../../services/document-viewer.service';
import * as FileSaver from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivityService } from "../activity.service";

@Component({
  selector: 'app-lion-email-details-popup',
  templateUrl: './email-details.component.html',
  styleUrls: ['./email-details.component.scss']
})

export class LionEmailDetailsPopupComponent implements OnInit, OnChanges {

  @Input() displayEmailDetailPopup;
  @Input() emailAudit: EmailAudit;
  @Input() emailAuditId;
  @Input() objectId;
  @Input() isViewMode = false;
  @Input() objectTypeId: number;
  emailAuditTemp: EmailAudit;
  emailThread: EmailThread;
  selectedIndex: number;
  @Output() cancelEmailPopupDetails = new EventEmitter<any>();
  @Output() syncSendEmail: EventEmitter<any> = new EventEmitter();
  @Output() openEmailDetail: EventEmitter<any> = new EventEmitter();

  sender: Type;
  from: Type;
  to: Type;
  cc: Type;
  bcc: Type;

  hasEmailCC = false;
  hasEmailBcc = false;
  displaySendEmail = false;
  flag;
  changeDitect: any;
  emailSubject: string = '';
  objectEmailAuditSentimentToolTip = "";
  showSpinner: boolean = false;

  attachList = [
    { id: 1, name: "document1.doc" },
    { id: 2, name: "sample.jpg" },
    { id: 3, name: "document2.doc" },
  ]
  attachOption: MenuItem[];
  attachTypes;

  constructor(
    private noteService: NoteService,
    private app: AppMainComponent,
    private messageService: MessageService,
    private appMainService: AppMainService,
    private confirmationService: ConfirmationService,
    private activityService: ActivityService,
    private logServiceForOtherMethods: CustomLogService,
    private emailAuditService: EmailAuditService,
    private documentViewerService: DocumentViewerService,
    public sanitizer: DomSanitizer) {
    //this.noteImages = images;
  }

  ngOnInit(): void {
    this.sender = this.app.emailRecipTypes.filter(elem => elem.name === "Sender")[0];
    this.from = this.app.emailRecipTypes.filter(elem => elem.name === "From")[0];
    this.to = this.app.emailRecipTypes.filter(elem => elem.name === "To")[0];
    this.cc = this.app.emailRecipTypes.filter(elem => elem.name === "CC")[0];
    this.bcc = this.app.emailRecipTypes.filter(elem => elem.name === "BCC")[0];


    ////console.log(`sender: ${this.sender.id},from: ${this.from.id},to: ${this.to.id},cc: ${this.cc.id},bcc: ${this.bcc.id},`)
    //this.findEmailCC();
    //this.emailSubject = this.emailAudit.subject;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.emailAudit;
    // console.log(this.emailAudit.emailThreads[0].emailAttachments)
    this.changeDitect = changes;

    for (let property in changes) {
      if (property === 'emailAudit' && this.emailAudit) {
        this.setEmailThread();
        // this.findEmailCC();
        //this.findEmailBCC();

        //for showing header of cc and bcc if they exist in email thread
        this.emailAudit.emailThreads.forEach(emailThread => {
          emailThread.emailRecipients.forEach(emailRec => {
            if (emailRec.type.name === "CC") {
              emailThread.hasCC = true;
            } else if (emailRec.type.name === "BCC") {
              emailThread.hasBcc = true;
            }
          });
        });
      }
    }

    if (changes?.isViewMode?.currentValue) {
      this.isViewMode = changes.isViewMode.currentValue;
    }
    this.objectEmailAuditSentimentToolTip = this.emailAudit?.objectEmailAuditSentiment?.explanation ? `Sentiment: ${this.emailAudit?.objectEmailAuditSentiment?.sentimentText}\nConfidence: ${this.emailAudit?.objectEmailAuditSentiment?.confidenceScore}\nExplanation: ${this.emailAudit?.objectEmailAuditSentiment?.explanation}` : ``;

    this.attachOption = [
      // {
      //   label: 'Preview',
      //   icon: 'pi pi-file',
      //   command: (attach) => {
      //     this.openFilePreview(attach);
      //   }
      // },
      // {
      //   label: 'Download',
      //   icon: 'pi pi-download',
      //   command: ($event) => {
      //     this.openFilePreview($event);
      //   }
      // },
    ];
  }

  setEmailThread() {
    this.emailSubject = this.emailAudit.subject;
    this.emailAuditTemp = this.app.copyObjectWithoutRefrence(this.emailAudit);
    this.emailThread = this.emailAudit ? this.emailAudit.emailThreads[0] : null;
    this.selectedIndex = 0;
    if (this.emailAudit.emailThreads.length > 0) {
      let initialMessage = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1];
      let initialSender = initialMessage?.emailRecipients?.filter(elem => elem.typeId === this.sender.id)[0];
      for (let i = 0; i < this.emailAudit.emailThreads.length; i++) {
        let thread = this.emailAudit?.emailThreads[i];
        for (let recip of thread.emailRecipients) {
          if (recip.emailAddress.toLowerCase() === initialSender?.emailAddress?.toLowerCase()) {
            thread["mailDirection"] = "Sent";
          } else {
            thread["mailDirection"] = "Received";
          }
        }
      }
    }
  }

  showThread(thread: EmailThread, index: number) {
    this.emailThread = thread;
    this.selectedIndex = index;
  }

  getLatestEmailChain(newEmailAudit: EmailAudit) {
    this.emailAudit = newEmailAudit;
    this.setEmailThread();
  }

  findEmailCC() {
    let emailThread = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1];

    for (let i = 0; i < emailThread.emailRecipients.length; i++) {
      let emailCC = emailThread.emailRecipients.filter(elem => elem.typeId === this.cc.id)[i];
      // if (emailCC?.typeId === 47) {
      //   emailCC.hasEmailCc = true;
      // }else{
      //   emailCC.hasEmailCc =false;
      // }
    }
  }

  findEmailBCC() {
    let emailThread = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1];
    for (let i = 0; i < emailThread.emailRecipients.length; i++) {
      let emailBCC = emailThread.emailRecipients.filter(elem => elem.typeId === this.bcc.id)[i];
      //   if (emailBCC?.typeId === 48) {

      //     emailBCC.hasEmailBcc= true;
      //   }else{
      //     emailBCC.hasEmailBcc = false;
      //   }
      // }
    }

  }

  startAction(actionType: string, flag: string, thread: EmailThread, index) {
    this.flag = flag;
    this.displaySendEmail = true;
    // //console.log("Flag", this.flag);
    // //console.log("thread", thread);
    // //console.log("index", index);

    let emailThread: EmailThread = {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "createdDate": new Date(),
      "emailAuditId": this.emailAudit.id,
      "messageId": this.emailAuditTemp.emailThreads[this.emailAuditTemp.emailThreads.length - 1].messageId,
      "conversationId": this.emailAuditTemp.emailThreads[this.emailAuditTemp.emailThreads.length - 1].conversationId,
      "subject": "",
      "messageData": "",
      "contentType": "html",
      "bodyPreview": "",
      "hasAttachment": false,
      "isDraft": false,
      "displayName": null,
      "userMail": null,
      "isRead": false,
      "receivedDateTime": null,
      "statusId": Status.Active,
      "isValid": true,
      "validFromDate": null,
      "validToDate": null,
      "emailRecipients": [],
      "emailAttachments": null
    }

    let indexF = this.emailAudit.emailThreads.findIndex(elem => elem.id === 0);
    if (indexF === -1) {
      this.emailAudit.emailThreads.push(emailThread);
    }

    if (flag === 'S' || flag === 'A') {
      this.emailAudit.subject = "RE: " + this.emailAuditTemp.emailThreads[index].subject;
      this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].subject = "RE: " + this.emailAuditTemp.emailThreads[index].subject;
      this.emailThread = thread;
      this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].messageData = '<br/><br/><br/><br/><br/><br/>' + thread?.messageData ?? '';

    } else {
      this.emailThread = thread;
      this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].subject = "FW: " + this.emailAuditTemp.emailThreads[index].subject;
      this.emailAudit.subject = "FW: " + this.emailAuditTemp.subject;
      this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].messageData = thread.messageData;
    }



  }

  cancelEmailSend() {
    //this.ngOnInit();

    this.displaySendEmail = false;
    //this.ngOnChanges(this.changeDitect);
    // this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].messageData = null;
    // this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].emailRecipients = null;
    // this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].createdDate = null;
    // this.emailAudit.subject = this.emailAudit.subject;
    this.emailAuditService.lionO36020APIEmailAuditIdGet(this.emailAuditId, true).subscribe((email: any) => {
      let emailAuditDetails: EmailAudit = email;
      emailAuditDetails.emailThreads.forEach(elem => { elem.receivedDateTime = elem.receivedDateTime });
      emailAuditDetails.emailThreads = emailAuditDetails.emailThreads.sort(function (left, right) {
        return moment.utc(right.receivedDateTime).diff(moment.utc(left.receivedDateTime))
      });
      this.emailAudit = emailAuditDetails;
      this.ngOnChanges(this.changeDitect);
      //console.log(this.emailAudit);
    }, err => console.log(err));

  }

  successEmailSend() {
    this.displayEmailDetailPopup = false;
    this.cancelEmailPopupDetails.emit({ "cancelLogPopupDetails": this.displayEmailDetailPopup });
  }

  cancelEmail() {
    this.displayEmailDetailPopup = false;
    this.hasEmailCC = false;
    this.hasEmailBcc = false;
    this.cancelEmailPopupDetails.emit({ "cancelLogPopupDetails": this.displayEmailDetailPopup });
    ////console.log("cancle call from child");

  }
  buildOptionsEvent(emailAttachment: any) {
    this.attachOption = [
      {
        label: 'Preview',
        icon: 'pi pi-file',
        command: () => {
          this.openFilePreview(emailAttachment);
        }
      },
      {
        label: 'Download',
        icon: 'pi pi-download',
        command: () => {
          // this.downloadedFile(emailAttachment?.attachment?.location);
          this.downloadedFile(emailAttachment);
        }
      },
    ];
  }
  openFilePreview(emailAttachment: any) {
    let docType: string = emailAttachment?.attachment?.extension;
    let encodedUrl = encodeURIComponent(emailAttachment?.attachment?.location);
    switch (docType) {
      case 'docx':
        this.documentViewerService.selectDocumentType(docType, encodedUrl);
        break;
      case 'xlsx':
        this.documentViewerService.selectDocumentType(docType, encodedUrl);
        break;
      case 'pptx':
        this.documentViewerService.selectDocumentType(docType, encodedUrl);
        break;
      case 'csv':
        this.documentViewerService.selectDocumentType(docType, encodedUrl);
        break;
      case 'pdf':
        this.documentViewerService.selectDocumentType(docType, emailAttachment?.attachment?.location);
        break;
      case 'jpg':
        this.documentViewerService.selectDocumentType(docType, emailAttachment?.attachment?.location);
        break;
      case 'png':
        this.documentViewerService.selectDocumentType(docType, emailAttachment?.attachment?.location);
        break;
      case 'gif':
        this.documentViewerService.selectDocumentType(docType, emailAttachment?.attachment?.location);
        break;
      case 'txt':
        this.documentViewerService.selectDocumentType(docType, emailAttachment?.attachment?.location);
        break;
      default:
        this.documentViewerService.selectDocumentType(docType, emailAttachment?.attachment?.location);
    }
  }

  downloadedFile(emailAttachment: any) {
    if (emailAttachment?.attachment?.location) {
      this.download(emailAttachment?.attachment?.location, emailAttachment?.attachment?.name)
    }
  }

  download(url: string, name: string) {
    this.emailAuditService.download(url).subscribe({
      next: (blob) => {
        try {
          FileSaver.saveAs(blob, name)
        } catch (error) {

        }
      }
    })
  }

  checkIcons(e) {
    switch (e) {
      case 'jpg': case 'jpeg': case 'png': case 'svg':
        return 'fa fa-file-image-o';
      case 'xlsx': case 'xlsm': case 'xlsb': case 'xltx':
        return 'fa fa-file-excel-o'
      case 'pdf': case 'docx': case 'txt':
        return 'fa fa-file-text-o'
      default:
        return 'fa fa-file-o'
    }
  }
  checkLabel(e) {
    if (e.length > 20) {
      return e.substr(0, 20) + '...';
    } else {
      return e;
    }
  }

  syncSendEmailNow(mailObj: any) {
    this.syncSendEmail.emit(mailObj);
  }

  refreshEmail(emailAuditId) {
    this.showSpinner = true;
    this.activityService.getEmailSync(this.objectId, this.objectTypeId, emailAuditId).subscribe(
      {
        next: (res) => {
          this.showSpinner = false;
          this.setEmailThread();
          this.openEmailDetail.emit({
            objectData: {
              objectEmailAudit: {
                emailAuditId: emailAuditId
              }
            }
          });
        },
        error: (error) => {
          this.showSpinner = false;
        }
      });
  }
}
